import { useState } from "react";
import { Modal } from "../ui/Modal";
import { Button } from "../ui/Button";
import { Input } from "../ui/Input";
import { Textarea } from "../ui/Textarea";

const TEMPLATE_CATEGORIES = [
  { value: "newsletter", label: "Newsletter" },
  { value: "promotional", label: "Promotional" },
  { value: "transactional", label: "Transactional" },
  { value: "onboarding", label: "Onboarding" },
];

export function EmailTemplateModal({ open, onClose, onSave, toast }) {
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [subject, setSubject] = useState("");
  const [preheader, setPreheader] = useState("");
  const [content, setContent] = useState("");

  const handleSave = () => {
    if (!name.trim()) {
      toast?.({ title: "Missing name", description: "Please enter a template name." });
      return;
    }
    onSave?.({ name: name.trim(), category, subject, preheader, content });
    toast?.({ title: "Template saved", description: `"${name.trim()}" has been saved.` });
    setName("");
    setCategory("");
    setSubject("");
    setPreheader("");
    setContent("");
    onClose?.();
  };

  const handleClose = () => {
    setName("");
    setCategory("");
    setSubject("");
    setPreheader("");
    setContent("");
    onClose?.();
  };

  return (
    <Modal open={open} onClose={handleClose} title="Create Email Template" maxWidth="560px">
      <p style={{ margin: "0 0 20px", fontSize: 14, color: "#6b7280" }}>
        Design and save reusable email templates for your campaigns.
      </p>
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <div>
          <label style={{ display: "block", marginBottom: 6, fontSize: 14, fontWeight: 500 }}>Template name</label>
          <Input placeholder="Template Name" value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div>
          <label style={{ display: "block", marginBottom: 6, fontSize: 14, fontWeight: 500 }}>Category</label>
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #d1d5db", fontSize: 14 }}
          >
            <option value="">Select category</option>
            {TEMPLATE_CATEGORIES.map((c) => (
              <option key={c.value} value={c.value}>{c.label}</option>
            ))}
          </select>
        </div>
        <div>
          <label style={{ display: "block", marginBottom: 6, fontSize: 14, fontWeight: 500 }}>Default subject line</label>
          <Input placeholder="Subject Line" value={subject} onChange={(e) => setSubject(e.target.value)} />
        </div>
        <div>
          <label style={{ display: "block", marginBottom: 6, fontSize: 14, fontWeight: 500 }}>Preheader (preview text)</label>
          <Input placeholder="Preheader" value={preheader} onChange={(e) => setPreheader(e.target.value)} />
        </div>
        <div>
          <label style={{ display: "block", marginBottom: 6, fontSize: 14, fontWeight: 500 }}>Email content</label>
          <Textarea placeholder="Write your email content here..." value={content} onChange={(e) => setContent(e.target.value)} rows={6} style={{ minHeight: 140 }} />
        </div>
        <div style={{ display: "flex", gap: 12, justifyContent: "flex-end", marginTop: 8 }}>
          <Button $variant="outline" onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSave}>Save Template</Button>
        </div>
      </div>
    </Modal>
  );
}
